// Site state
const state = {
  sites: {},
  active: {},
  newSite: {
    name: '',
    tc_api_key: '',
    tc_api_secret: '',
    brand: {},
    defaultLanguage: {},
    json: {}
  },
  allSites: []
}

export default state
